module.exports = __webpack_public_path__ + "static/media/Sending-Mail@medium.jpg";